import { nanoid } from "@reduxjs/toolkit";
import { ChangeEventHandler, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/Modal";
import BrandCompanyForm from "../../components/admin/BrandCompanyForm";
import  {
  Tbody,
  Thead,
} from "../../components/custom/components/AdminTable";
import AdminLayout from "../../components/custom/layouts/AdminLayout";
import { ToastTypes, useToast } from "../../components/toast/ToastProvider";
import { FormType, FormTypeList } from "../../config";
import {
  BrandCompanyType,
  deleteBrandCompany,
  fetchBrandCompany,
} from "../../redux/actions/brandCompanyActions";
import { AppDispatch, StoreState } from "../../redux/store";
import DeleteConfirmationForm from "../../components/admin/DeleteConfirmationForm";
import { BrandType } from "../../redux/actions/brandActions";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import AdminTable2 from "../../components/custom/components/AdminTable2";
import { AuthAdminType } from "../../redux/actions/authAdminActions";
import { AdminLog } from "../../config/common";

// interface TableBody {
//     sno: number
//     name: string
//     url: string
//     street: string
//     city: string
//     state: string
//     country: string
//     pincode: string
//     phone: string
//     active: ActiveTypes | boolean
//     onEdit: MouseEventHandler<HTMLButtonElement>
//     onDelete: MouseEventHandler<HTMLButtonElement>
//     onView: MouseEventHandler<HTMLButtonElement>
// }

// type HandleEdit = (value: BrandCompanyType) => void
type HandleDelete = (value: BrandCompanyType) => void;
// type HandleView = (value: BrandCompanyType) => void

const BrandCompany = () => {
  const toast = useToast();
  const dispatch = useDispatch<AppDispatch>();
  const pageName = useLocation()
  const navigate = useNavigate();
  const authAdmin = useSelector<StoreState, AuthAdminType | null>(
    (state) => state.authAdmin
  );
  const adminAuthendicated =
  typeof authAdmin?.["auth-token"] === "string" &&
  authAdmin?.["auth-token"] !== undefined &&
  authAdmin?.["auth-token"] !== "";
  const BrandCompanyList = useSelector<StoreState, Array<BrandCompanyType>>(
    (state) => state.brandCompany
  );
  const BrandList = useSelector<StoreState, Array<BrandType>>(
    (state) => state.brand
  );

  const [showForm, setShowForm] = useState<boolean>(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] =
    useState<boolean>(false);
  const [formType, setFormType] = useState<FormType>(FormTypeList.ADD);
  const [editData, setEditData] = useState<BrandCompanyType>();
  const [disableDelete, setDisableDelete] = useState<boolean>(false);
  const [deleteData, setDeleteData] = useState<BrandCompanyType>();
  const [showViewForm, setShowViewForm] = useState<boolean>(false);
  const [id, setId] = useState<number>();

  const [searchQuery, setSearchQuery] = useSearchParams();
  const searchTerm = searchQuery.get("search") || "";

  const searchBrandCompanyHandler = (
    BrandCompany: BrandCompanyType,
    searchTerm: string
  ) => {
    return searchTerm !== ""
      ? new RegExp(`^${searchTerm}|${searchTerm}`, "gi").test(BrandCompany.name)
      : true || [];
  };

  const searchHandler: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearchQuery({ search: e.target.value });
  };

  const [brandCompanyData, setBrandCompanyData] = useState<BrandCompanyType[]>(
    []
  );

  const limit = 20;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(0);

  useEffect(() => {
    if (BrandCompanyList?.length > 0) {
      setLength(BrandCompanyList?.length ? BrandCompanyList?.length : 0);
    }
  }, [BrandCompanyList]);

    useEffect(()=>{
     navigate("/admin/brand_company");
  },[])


  const handleApply = async (offsetVal = offset) => {
    if (BrandCompanyList?.length > 0) {
      const getData = {
        limit: limit?.toString(),
        offset: offsetVal?.toString(),
      };

      if (
        getData !== undefined &&
        getData.limit !== "" &&
        getData.offset !== "" &&
        getData.offset !== undefined &&
        getData.offset !== "NaN"
      ) {
        const filteredBrandCompanyList: BrandCompanyType[] =
          BrandCompanyList?.slice(offset, limit + offset);
        if (filteredBrandCompanyList?.length > 0) {
          setBrandCompanyData([...filteredBrandCompanyList]);
        } else {
          setBrandCompanyData([]);
        }
      }
    }
  };

  useEffect(() => {
    handleApply();
  }, [BrandCompanyList]);

  const getTableData = () => {
    var tableHead: Thead[] = [
      { id: "S.No", children: "S.No", text: "S.No" },
      {
        id: "Brand Company Name",
        children: "Brand Company Name",
        text: "Brand Company Name",
      },
      { id: "Website URL", children: "Website URL", text: "Website URL" },
      { id: "Street", children: "Street", text: "Street" },
      { id: "City", children: "City", text: "City" },
      { id: "State", children: "State", text: "State" },
      { id: "Country", children: "Country", text: "Country" },
      { id: "Pincode", children: "Pincode", text: "Pincode" },
      { id: "Phone", children: "Phone", text: "Phone" },
      { id: "Status", children: "Status", text: "Status" },
      { id: "Action", children: "Action", text: "Action" },
    ];
    var tableBody: Tbody[][] = [];

    brandCompanyData
      .filter((cr) => searchBrandCompanyHandler(cr, searchTerm))
      .forEach((item, i) => {
        // item.forEach(v => {
        //     selectedYears.forEach((sy) => {
        const pageNumber = Math.floor(offset / limit) + 1;
        var tBody: Tbody[] = [];
        tBody.push(
          {
            id: nanoid(),
            theadId: "S.No",
            children: limit * pageNumber + i - limit + 1,
            text: (limit * pageNumber + i - limit + 1)?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Brand Company Name",
            children: item.name,
            text: item.name,
            className: "text-truncate",
          },
          {
            id: nanoid(),
            theadId: "Website URL",
            children: item.url,
            text: item.url,
          },
          {
            id: nanoid(),
            theadId: "Street",
            children: item.street,
            text: item.street,
          },
          {
            id: nanoid(),
            theadId: "City",
            children: item.city,
            text: item.city,
          },
          {
            id: nanoid(),
            theadId: "State",
            children: item.state,
            text: item.state,
          },
          {
            id: nanoid(),
            theadId: "Country",
            children: item.country,
            text: item.country,
          },
          {
            id: nanoid(),
            theadId: "Pincode",
            children: item.pincode,
            text: item.pincode,
          },
          {
            id: nanoid(),
            theadId: "Phone",
            children: item.phone,
            text: item.phone?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Status",
            children: item.active ? "Active" : !item.active ? "InActive" : "",
            text: item.active ? "Active" : !item.active ? "InActive" : "",
          },
          {
            id: nanoid(),
            theadId: "Action",
            children: "action",
            className: "d-none",
            text: item.id?.toString(),
          }
        );
        tableBody.push(tBody);
        // })
      });

    return { tbody: tableBody, thead: tableHead };
  };

  const handleAdd = () => {
    setShowForm(true);
    

    if(adminAuthendicated){
      const logProps1 = {
        action: 'Create',
        event: `${pageName.pathname.replace("\\", " ")} page | Create Brand Company Clicked`
      };
      AdminLog(logProps1)
    }
 
  };

  const handleView = () => {
    setFormType(FormTypeList.VIEW);
    if (id !== undefined) {
      var obj = BrandCompanyList.find((c) => c.id === id);
      setShowForm(true);
      setEditData(obj);
      setShowViewForm(true);
      if(adminAuthendicated){
        const logProps1 = {
          action: 'View',
          event: `${pageName.pathname.replace("\\", " ")} page |  ${obj?.name} BrandCompany Viewed | View Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handleDeleteConfirmation = () => {
    setFormType(FormTypeList.DELETE);
    if (id !== undefined) {
      var obj = BrandCompanyList.find((c) => c.id === id);
      setShowDeleteConfirmation(true);
      const brandLists = BrandList.filter((bl) => bl.companyid === id);
      setDeleteData(obj);
      setDisableDelete(brandLists?.length > 0 ? true : false);
    }
  };

  const handleEdit = () => {
    setFormType(FormTypeList.EDIT);
    if (id !== undefined) {
      var obj = BrandCompanyList.find((c) => c.id === id);
      setEditData(obj);
      setShowForm(true);
      if(adminAuthendicated){
        const logProps1 = {
          action: 'Edit',
          event: `${pageName.pathname.replace("\\", " ")} page | BrandCompany - ${obj?.name}  | Edit Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handleDelete: HandleDelete = (value) => {
    if (value.id !== undefined) {
      dispatch(deleteBrandCompany(value.id))
        .then(async (text) => {
          dispatch(fetchBrandCompany());
          toast(text, ToastTypes.SUCCESS);
          var obj = BrandCompanyList.find((c) => c.id === id);
          if(adminAuthendicated){
            const logProps1 = {
              action: 'Delete',
              event: `${pageName.pathname.replace("\\", " ")} page |  ${obj?.name} BrandCompany | Delete Clicked`
            };
            AdminLog(logProps1)
          }
          if (brandCompanyData !== undefined && brandCompanyData?.length === 1) {
            let newOffset = offset - limit < 0 ? 0 : offset - limit;
            setOffset(newOffset);
            await handleApply(newOffset);
          } else {
            await handleApply(); //issue starts from here
          }
          handleFormClose();
        })
        .catch((text) => {});
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setFormType(FormTypeList.ADD);
    setEditData(undefined);
    setId(undefined);
    setShowViewForm(false);
    setShowDeleteConfirmation(false);
  };

  useEffect(() => {
    if (id !== undefined && formType === FormTypeList.VIEW) handleView();
    else if (id !== undefined && formType === FormTypeList.EDIT) handleEdit();
    else if (id !== undefined && formType === FormTypeList.DELETE)
      handleDeleteConfirmation();
  }, [id, formType]);

  useEffect(() => {
    var range = [];
    var num = Math.ceil(length / limit);
    // let i = 1;

    for (let i = 1; i <= num; i++) {
      range.push(i);
    }

    setRange(range);
  }, [length, limit]);

  useEffect(()=>{
    if(adminAuthendicated){
    const logProps1 = {
      action:`Visit`,
      event: `${pageName.pathname.replace("\\", " ")} page | Visited `
    };
    AdminLog(logProps1)
  }
  },[])

  return (
    <>
      <Modal
        headerText={formType + " BRAND COMPANY"}
        visible={showForm}
        onClose={handleFormClose}
        size="xl"
        centered
      >
        <BrandCompanyForm
          formType={formType}
          editData={editData}
          onSave={handleFormClose}
          showViewForm={showViewForm}
        />
      </Modal>
      <Modal
        headerText={formType + " BRAND COMPANY"}
        visible={showDeleteConfirmation}
        onClose={handleFormClose}
        size="lg"
        centered
      >
        <DeleteConfirmationForm
          deleteLabel={
            disableDelete
              ? "Brand company is in use. Deletion not allowed."
              : "Do you really want to delete the records with the brand company - " +
                deleteData?.name
          }
          onCancel={handleFormClose}
          onDelete={() => (disableDelete ? {} : handleDelete(deleteData!))}
        />
      </Modal>
      <AdminLayout>
        {/* <PageTitle
                title='Brand Company Management'
                buttonText='Create New Brand Company'
                onButtonClick={handleAdd}
            /> */}
        <AdminTable2
          addBtnText="Create New Brand Company"
          onAdd={handleAdd}
          onEdit={handleEdit}
          onDelete={handleDeleteConfirmation}
          onView={handleView}
          search={searchHandler}
          limit={limit}
          setOffset={setOffset}
          offset={offset}
          onPageNoChange={handleApply}
          range={range}
          pageTitle="Brand Company Management"
          path="/admin/brand_company"
          // data={data}
          setId={setId}
          {...getTableData()}
        />
        {/* <div className="card mt-3">
                <div className="card-body">
                    <div className='row'>
                        <div className="col-lg-6 col-sm-12">
                            <h5 className="header-title mb-3 float-start"><i className="fe-align-justify me-1 text-primary"></i>Brand Company Management</h5>
                        </div>
                        <div className="col-lg-6 col-sm-12 text-end mb-1">
                            <button type="button" onClick={handleAdd} className={`me-1 btn btn-xs btn-secondary`}>Create New Brand Company</button>
                        </div>
                    </div>
                    <hr className='hr mt-0' />
                    <div className='table-wrapper'>
                        <table className='table colored'>
                            <thead>
                                <tr>
                                    <th className='text-truncate align-middle'>S.No</th>
                                    <th className='text-truncate align-middle text-center'>Brand Company Name</th>
                                    <th className='text-truncate align-middle text-center'>Website URL</th>
                                    <th className='text-truncate align-middle text-center'>Street</th>
                                    <th className='text-truncate align-middle text-center'>City</th>
                                    <th className='text-truncate align-middle text-center'>State</th>
                                    <th className='text-truncate align-middle text-center'>Country</th>
                                    <th className='text-truncate align-middle text-center'>Pincode</th>
                                    <th className='text-truncate align-middle text-center'>Phone</th>
                                    <th className='text-truncate align-middle text-center'>Status</th>
                                    <th className='text-truncate align-middle text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {BrandCompanyList.map((u, i) => {
                                    return <BrandCompanyBody
                                        sno={i + 1}
                                        name={u.name}
                                        url={u.url}
                                        street={u.street}
                                        city={u.city}
                                        state={u.state}
                                        country={u.country}
                                        pincode={u.pincode}
                                        phone={u.phone}
                                        active={u.active}
                                        key={i}
                                        onEdit={() => handleEdit(u)}
                                        onDelete={() => handleDelete(u)}
                                        onView={() => handleView(u)}
                                    />
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> */}
      </AdminLayout>
    </>
  );
};

// const BrandCompanyBody = ({ sno, name, url, street, city, state, country, pincode, phone, active, onView, onEdit, onDelete }: TableBody) => {
//     return <tr>
//         <td className='align-middle text-center'>{sno}</td>
//         <td className='align-middle'>{name}</td>
//         <td className='align-middle'>{url}</td>
//         <td className='align-middle'>{street}</td>
//         <td className='align-middle'>{city}</td>
//         <td className='align-middle'>{state}</td>
//         <td className='align-middle'>{country}</td>
//         <td className='align-middle'>{pincode}</td>
//         <td className='align-middle'>{phone}</td>
//         <td className='align-middle'>{active ? "Active" : "InActive"}</td>
//         <td>
//             <div className='hstack gap-1'>
//                 <button className='btn btn-sm btn-secondary' onClick={onEdit}>Edit</button>
//                 <button className='btn btn-sm btn-secondary' onClick={onDelete}>Delete</button>
//                 <button className='btn btn-sm btn-secondary' onClick={onView}>View</button>
//             </div>
//         </td>
//     </tr>
// }

export default BrandCompany;
